import React, { useState, useEffect } from "react";
import SubmitButton from "../SubmitButton/SubmitButton";
import styles from "./LoginForm.module.css";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../App.js";
import { Link } from "react-router-dom";

export default function LoginForm() {
    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });
    // UPDATED: Replaced showError with msg state for status control
    const [msg, setMsg] = useState({ type: "", text: "" });

    const navigate = useNavigate();

    // NEW: useEffect hook to dismiss error messages after 5 seconds
    useEffect(() => {
        if (msg.text && msg.type === "error") {
            const timer = setTimeout(() => {
                setMsg({ type: "", text: "" }); // Clear the message
            }, 5000); // 5000 milliseconds = 5 seconds

            // Cleanup function
            return () => clearTimeout(timer);
        }
    }, [msg]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        // UPDATED: Clear error when typing again
        setMsg({ type: "", text: "" });
    };

    async function handleSubmit(event) {
        event.preventDefault();
        // UPDATED: Clear any previous message before new submission
        setMsg({ type: "", text: "" });

        try {
            const res = await fetch(`${BASE_URL}backend/login.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
                credentials: 'include'
            });

            // If PHP always returns JSON:
            const data = await res.json();
            if (res.ok && data?.success) {
                // If successful, navigate immediately
                navigate("/home");
            } else {
                // UPDATED: Set detailed error message
                setMsg({ type: "error", text: "Invalid email or password" });
            }
        } catch (e) {
            console.error(e);
            // UPDATED: Set detailed error message for unexpected error
            setMsg({ type: "error", text: "An unexpected error occurred. Please try again." });
        }
    }


    return (
        <div className={styles.component}>
            <h2>Log In</h2>
            <form id="login" className={styles.login} onSubmit={handleSubmit}>
                <div className={styles.field}>
                    <input type="email" id="email" className={styles.emailinput}
                           value={formData.email} onChange={handleChange} name="email"
                           placeholder="Email" autoComplete="email" required
                           pattern="^[^@\s]+@[^@\s]+\.(com|edu)$"/>
                </div>
                <div className={styles.field}>
                    <input type="password" id="pw" className={styles.pwinput} placeholder="Password"
                           value={formData.password} onChange={handleChange}
                           autoComplete="current-password" name="password" required/>
                </div>
            </form>
            {/* separated button into sep component for styling and reuse */}
            <SubmitButton className={styles.submit} form="login">Log In</SubmitButton>

            {/* links that redirect to other pages */}
                    <div className={styles.forgot}>
                        <Link to="/forgot">Forgot your password?</Link>
                    </div>
                    <div className={styles.signup}>
                        <Link to="/register">Don't have an account yet? Sign up</Link>
                    </div>

            {/* NEW/UPDATED: Message display using the same structure as RegisterPage */}
            {msg.text && (
                <div
                    className={
                        msg.type === "success"
                            ? styles.alertSuccess
                            : styles.alertError
                    }
                    role="status"
                >
                    <p>{msg.text}</p>
                </div>
            )}
        </div>
    )
}